import React, { Fragment, useEffect, useState } from 'react'
import FlatList from 'flatlist-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { Loading } from '../components/Loading';
import { Loading } from '../../components/Loading';
import Select from 'react-select'

export const DocFirmados = () => {


  const data = useSelector(state => state.login.data)

  const rut = data.personaId
  
  // console.log('data',data)

  const conid = localStorage.getItem('conid')


let navigate = useNavigate();


  const [loading, setLoading] = useState(true)
       
  const [objPdf, setobjPdf] = useState([])



        const consultarDatos = async () => {
          try {
            // setLoading(true)

              const response = await axios.get(`${process.env.REACT_APP_API_URL_BACK}api/firma/con-firmar/${rut}/${conid}`);
                      
              // console.log(response.data)
                
              setobjPdf(response.data)

                  // console.log(response.data)

                  setLoading(false)


              } catch (error) {
                
              alert("Error de conexion","Intentalo otra vez", );
              setLoading(false)
                  
              }


      }

      useEffect(() => {

          consultarDatos()
      }, [])

      // console.log(objPdf,'objPdf')


      const documentos = [
        { value: 'Contrato', label: 'Contrato' },
        { value: 'Anexo', label: 'Anexo' },
        { value: 'Liquidación', label: 'Liquidación' },
        { value: 'Otros Documentos', label: 'Otros Documentos' }
      ]

      const [docAFiltrar, setDocAFiltrar] = useState('')

      // console.log(docAFiltrar,'docAFiltrar')

      const [documentosFiltrados, setDocumentosFiltrados] = useState('')


      useEffect(() => {
        
        if(docAFiltrar.value === 'Otros Documentos'){

              const docFiltrados = objPdf.filter(item => item.tipo !== 'Contrato' && item.tipo !== 'Anexo' && item.tipo !== 'Liquidación')

              // console.log(docFiltrados,'docFiltrados')



              setDocumentosFiltrados(docFiltrados)


        } else {
          const docFiltrados = objPdf.filter(item => item.tipo == docAFiltrar.label)

          // console.log(docFiltrados,'docFiltrados')



          setDocumentosFiltrados(docFiltrados)
        }
 
      }, [docAFiltrar])
      
    
      function restablecerFiltros(){
          
        setDocAFiltrar('')


      }
 

  return (

    <>

        <div className='contenedorDocPorFirmar' >

              <div className='contenedorFiltros' >
                    <p>Filtrar por documento</p>

                    <Select className='selectDocumentoTipo' options={documentos } value={docAFiltrar} onChange={setDocAFiltrar}  />

                    <button className='restablecerFiltrosButton'  onClick={restablecerFiltros} >
                      Restablecer filtro
                    </button>

              </div>


              <div className='contenidoTodoTablaDocPorFirmar' > 
                          {/* header tabla */}
                          <div className='headerTablaDocPorFirmar' >

                            <p>Fecha firma</p>
                            <p>Tipo de documento</p>
                            <p>Accion</p>


                          </div>
                          

                          <div className='contenidoTablaDocPorFirmar' >

                            {
                              loading ? <div className='marginTopFirmas'><Loading/> </div> :

                              <FlatList list={docAFiltrar ? documentosFiltrados : objPdf} renderItem={(item,index) => 
                                <div key={index} className='divflat' >
                                  

                                  <p>{item.fechaTrabajador}</p>



                                    <p>{item.tipo}</p>

                            


                                    <p className='firmar' onClick={ () => navigate(`/verpdf/${item.id}/${item.codper}`)}  > Ver </p>

                                
                                    


                                </div>
                        
                        
                        
                        
                              
                              }
                              
                              renderWhenEmpty={() =>
                                <div className='renderEmpty' >

                                  
                                    <p> No has firmado documentos </p>
                                  

                              

                                </div>
                              }
                              hasMoreItems
                              renderOnScroll
                              />
                            }

                              



                          </div>


                          



              </div>
                







        </div>




   </>
   

  )
}
